/* eslint-disable security/detect-unsafe-regex */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { useState, useEffect } from 'react';
import { IMoeViewcollectionsViewProps } from './moe-viewcollections';
import { INodeProps, Modal, Node, Button } from '@msdyn365-commerce-modules/utilities';
import { FaEnvelopeOpenText, FaShareAlt, FaCheck, FaTimesCircle } from 'react-icons/fa';

// import { IPriceComponentResources } from '@msdyn365-commerce/components';
// import { ProductItems } from './components/product-items';
import { CollectionItem } from '../../components/collectionitem.component';
import {
    getByCustomerAsync,
    updateAsync,
    deleteAsync,
    createInvitationsAsync
    // removeLinesAsync,
    // createGetByCustomerInput
} from '@msdyn365-commerce/retail-proxy/dist/DataActions/CommerceListsDataActions.g';
import { AsyncResult } from '@msdyn365-commerce/retail-proxy';
import { getMOEWishListAsync } from '../../actions/extensions/DataActionExtension.g';
import { getUrlSync } from '@msdyn365-commerce/core';
import { getToggleLang, getUserPreferredLanguage, getUserPrefLang } from '../../utilities/language-change';
import { MAORI_LANG, ERROR_OR_NOTIFICATION, ACTION_BUTTONS, COLLECTIONS_SITE_LANGUAGE } from '../../utilities/constants';

export default (props: IMoeViewcollectionsViewProps) => {
    // Variable definitions
    const collectionMockData: any = [];
    const user = props.context.request.user;
    const { context, resources } = props;
    const channelConfiguration = context?.request?.channel;
    const toggleLang = getToggleLang(context);
    const userPrefLang = getUserPrefLang(user.customerAccountNumber as any, context);
    //const finalLang = getUserPreferredLanguage("kwr", MY_PROFILE, userPrefLang, toggleLang);
    const errorOrNotificationMsgLang = getUserPreferredLanguage(
        props.config.siteName as any,
        ERROR_OR_NOTIFICATION,
        userPrefLang,
        toggleLang,
        context
    );
    // Need to make change
    const collectionSiteLang = getUserPreferredLanguage(
        props.config.siteName as any,
        COLLECTIONS_SITE_LANGUAGE,
        userPrefLang,
        toggleLang,
        context
    );
    const ActionBtnLang = getUserPreferredLanguage(props.config.siteName as any, ACTION_BUTTONS, userPrefLang, toggleLang, context);
    const CollectionLang = getUserPreferredLanguage(
        props.config.siteName as any,
        COLLECTIONS_SITE_LANGUAGE,
        userPrefLang,
        toggleLang,
        context
    );

    const appendLangWordErr = errorOrNotificationMsgLang === MAORI_LANG ? 'InMaori' : '';
    const appendLangWordActionBtn = ActionBtnLang === MAORI_LANG ? 'InMaori' : '';
    const appendLangWordCollections = CollectionLang === MAORI_LANG ? 'InMaori' : '';
    //@ts-ignore
    const { redirectionLink } = props.config;
    const MoeErrorMessages = {
        unknownError: props.resources[`unknownError${appendLangWordErr}`],
        emptyCollection: props.resources[`emptyCollection${appendLangWordErr}`],
        emptyCollections: props.resources[`emptyCollections${appendLangWordErr}`],
        duplicateName: props.resources[`duplicateName${appendLangWordErr}`],
        duplicateResource: props.resources[`duplicateResource${appendLangWordErr}`],
        unAuthenticated: props.resources[`unAuthenticated${appendLangWordErr}`],
        exceededCollectionNameLimit: props.resources[`exceededCollectionNameLimit${appendLangWordErr}`],
        noAccountNumber: props.resources[`noAccountNumber${appendLangWordErr}`],
        networkOffline: props.resources[`networkOffline${appendLangWordErr}`],
        duplicatePendingName: props.resources[`duplicatePendingName${appendLangWordErr}`],
        ownEmailAddress: props.resources[`ownEmailAddress${appendLangWordErr}`],
        InvalidEmailAddressFormat: props.resources[`invalidEmailAddressFormat${appendLangWordErr}`],
        InvalidEmailAddress: props.resources[`invalidEmailAddress${appendLangWordErr}`],
        NoInputEmailText: props.resources[`noInputEmailText${appendLangWordErr}`],
        unknownErrorInMaori: props.resources[`unknownError${appendLangWordErr}`],
        emptyCollectionInMaori: props.resources[`emptyCollection${appendLangWordErr}`],
        emptyCollectionsInMaori: props.resources[`emptyCollections${appendLangWordErr}`],
        duplicateNameInMaori: props.resources[`duplicateName${appendLangWordErr}`],
        duplicateResourceInMaori: props.resources[`duplicateResource${appendLangWordErr}`],
        unAuthenticatedInMaori: props.resources[`unAuthenticated${appendLangWordErr}`],
        exceededCollectionNameLimitInMaori: props.resources[`exceededCollectionNameLimit${appendLangWordErr}`],
        noAccountNumberInMaori: props.resources[`noAccountNumber${appendLangWordErr}`],
        networkOfflineInMaori: props.resources[`networkOffline${appendLangWordErr}`],
        duplicatePendingNameInMaori: props.resources[`duplicatePendingName${appendLangWordErr}`],
        ownEmailAddressInMaori: props.resources[`ownEmailAddress${appendLangWordErr}`],
        InvalidEmailAddressFormatInMaori: props.resources[`invalidEmailAddressFormat${appendLangWordErr}`],
        InvalidEmailAddressInMaori: props.resources[`invalidEmailAddress${appendLangWordErr}`],
        NoInputEmailTextInMaori: props.resources[`noInputEmailText${appendLangWordErr}`]
    };
    const MoeProfileMessages = {
        noCollections: props.resources[`noCollections${appendLangWordErr}`],
        pendingCollections: props.resources[`pendingCollections${appendLangWordErr}`],
        hey: props.resources[`hey${appendLangWordErr}`],
        notLoginToViewCollection: props.resources[`notLoginToViewCollection${appendLangWordErr}`],
        deleteConfirmationText: props.resources[`deleteConfirmationText${appendLangWordCollections}`],
        cancel: props.resources[`cancel${appendLangWordActionBtn}`],
        yes: props.resources[`yes${appendLangWordActionBtn}`],
        close: props.resources[`close${appendLangWordActionBtn}`],
        shareCollectionsText: props.resources[`shareCollectionsText${appendLangWordActionBtn}`],
        noEmailShareCollectionTitle: props.resources[`noEmailShareCollectionTitle${appendLangWordActionBtn}`],
        emailShareCollectionTitle: props.resources[`emailShareCollectionTitle${appendLangWordActionBtn}`]
    };

    const moeSuccessMessages = {
        deleteCollection: props.resources[`deleteCollection${appendLangWordErr}`],
        approvePendingCollection: props.resources[`approvePendingCollection${appendLangWordErr}`],
        shareCollection: props.resources[`shareCollection${appendLangWordErr}`],
        deletePendingCollection: props.resources[`deletePendingCollection${appendLangWordErr}`],
        updateCollectionName: props.resources[`updateCollectionName${appendLangWordErr}`]
    };

    // const MoeSuccessMessages = {
    //     createCollection: 'Collection has been successfully created.',
    //     addResource: 'Resource has been added to the collection.',
    //     updateCollection: 'Collection has been successfully updated.',
    //     deleteCollection: 'Collection has been successfully removed.',
    //     deleteProduct: 'Resource has been successfully removed from the collection.'
    // };

    // State definitions
    const [isShareCollectionModalOpen, setShareCollectionModalOpen] = useState(false);
    const [sharedCollectionIDs, setSharedCollectionIDs] = useState<string[]>([]);
    const [collectionShareEmail, setCollectionShareEmail] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(false);
    const [collectionArray, setCollectionArray] = useState<any[]>(collectionMockData);
    const [isCollectionEditable, setIsCollectionEditable] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [errorMessage, setErrorMessage] = useState<any>('');
    const [shareErrorMessage, setShareErrorMessage] = useState('');
    const [isAlertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState<any>('');
    const [isRefreshPage, setIsRefreshPage] = useState(false);
    const [isDelete, setDelete] = useState<number | null>(null);
    const [otherSiteCollectionCount, setOtherSiteCollectionCount] = useState<any>({});

    // Side effects
    useEffect(() => {
        async function getCollectionList() {
            if (user?.isAuthenticated) {
                try {
                    const { context } = props;
                    const collectionList = await getByCustomerAsync({ callerContext: context.actionContext, bypassCache: 'get' }, null);
                    setCollectionArray([...collectionList]);
                    const otherSitesCollectionList = await getMOEWishListAsync(
                        { callerContext: context.actionContext, bypassCache: 'get' },
                        0,
                        user.customerAccountNumber as any,
                        false,
                        false
                    );

                    const collectionsCount = {};
                    otherSitesCollectionList.forEach((item: any) => {
                        let count = 0;
                        item.MOECommerceListLines.length &&
                            item.MOECommerceListLines.forEach((commItem: any) => {
                                if (
                                    commItem.ProductDetails &&
                                    commItem.ProductDetails[0]?.Channel &&
                                    commItem.ProductDetails[0]?.Channel !== channelConfiguration?.RecordId
                                ) {
                                    count++;
                                }
                            });

                        collectionsCount[item.Id] = count;
                    });
                    setOtherSiteCollectionCount(collectionsCount);
                    console.log('Get all the customers data1111', otherSitesCollectionList);
                } catch (err) {
                    setErrorMessage(MoeErrorMessages.unknownError);
                    console.error(err);
                }
            }
        }

        void getCollectionList();
    }, [sharedCollectionIDs]);

    const openShareCollectionModal = (): void => {
        setShareCollectionModalOpen(true);
    };

    const closeShareCollectionModal = (): void => {
        setShareCollectionModalOpen(false);
    };

    const onClickCollection = (index: number, collectionId: number, collectionProducts: any[]) => {
        const wishlistURL: any = getUrlSync('wishlist', props.context.actionContext);
        const decodedWishlistURL = decodeURIComponent(wishlistURL);
        console.log(decodedWishlistURL);
        console.log('inside view collection click');
        const separator = decodedWishlistURL?.includes('?') ? '&' : '?';
        window.location.assign(`${decodedWishlistURL}${separator}cid=${collectionId}`);
    };

    const _shareCollectionModal = (): INodeProps => {
        return {
            tag: Modal,
            placement: 'bottom-end',
            hideArrow: true,
            className: 'ms-share-collection-container',
            wrapClassName: 'ms-share-collection__modal',
            isOpen: isShareCollectionModalOpen,
            toggle: closeShareCollectionModal
        };
    };

    const onCheckboxSelect = (event: React.ChangeEvent<HTMLInputElement>, collectionId: string, isChecked: boolean) => {
        let selectedCollectionIDs = sharedCollectionIDs;

        if (event?.target?.checked) {
            selectedCollectionIDs = [...selectedCollectionIDs, collectionId];
        } else {
            selectedCollectionIDs = selectedCollectionIDs.filter(el => el !== collectionId);
        }

        console.log(selectedCollectionIDs);
        setSharedCollectionIDs(selectedCollectionIDs);
    };

    const onShareEmailChange = (value: string) => {
        setCollectionShareEmail(value);
        if (value === '') {
            setIsValidEmail(false);
        } else {
            setIsValidEmail(true);
        }
    };

    const onShareCollectionButtonClick = async () => {
        setShareErrorMessage('');
        const { context } = props;
        if (!user?.isAuthenticated) {
            return;
        }
        if (user.emailAddress === collectionShareEmail) {
            setShareErrorMessage(MoeErrorMessages.ownEmailAddress);
            return;
        }
        if (!isValidEmail) {
            setShareErrorMessage(MoeErrorMessages.NoInputEmailText);
            return;
        }

        // Regex to check whether the given email is valid
        const regexp = new RegExp(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        const isEmail = regexp.test(collectionShareEmail);
        if (!isEmail) {
            setShareErrorMessage(MoeErrorMessages.InvalidEmailAddressFormat);
            return;
        }
        //const isEmailValid: any = await getValidEmailId(collectionShareEmail);
        //console.log('isEmailValid', isEmailValid);

        setShareErrorMessage('');
        for (const cid of sharedCollectionIDs) {
            const sharedWishlist = await createInvitationsAsync({ callerContext: context.actionContext }, parseInt(cid, 10), [
                { Invitee: collectionShareEmail, InvitationTypeValue: 1 }
            ]);
            console.log(sharedWishlist);
        }
        setCollectionShareEmail('');
        setShareCollectionModalOpen(false);
        openAlert(moeSuccessMessages.shareCollection, false);
    };

    const toggleEditableCollection = (index: any) => {
        setCurrentIndex(index);
        console.log(index, currentIndex, isCollectionEditable);
        setIsCollectionEditable(!isCollectionEditable);
    };

    // @info: This method checks the internet connection
    const isInternetConnectionAvailable = () => {
        if (window?.navigator?.onLine === false) {
            setErrorMessage(MoeErrorMessages.networkOffline);
            return false;
        } else if (window?.navigator?.onLine === true) {
            return true;
        }
        return;
    };

    // @info: This method is used to check whether the collection exists
    const doesCollectionExist = async (collectionId: number): Promise<any> => {
        const { context } = props;
        const collectionArray = await getByCustomerAsync({ callerContext: context.actionContext, bypassCache: 'get' }, null);
        if (!collectionArray || !collectionArray[0]) {
            return false;
        }
        console.log(collectionArray);

        const collection = collectionArray.find(collectionItem => collectionItem.Id === collectionId);

        console.log(collection);

        if (!collection) {
            return false;
        } else {
            return true;
        }
    };

    // @info: This method checks whether given name already exists in the existing collections
    const doesDuplicateNameExists = async (collectionName: string): Promise<any> => {
        const { context } = props;
        const collectionList = await getByCustomerAsync({ callerContext: context.actionContext, bypassCache: 'get' }, null);
        // setCollectionArray(collectionList);
        if (collectionList) {
            const filteredItem = collectionList.find(collection => collection?.Name === collectionName);
            if (filteredItem) {
                return true;
            } else {
                return false;
            }
        } else {
            setErrorMessage(MoeErrorMessages.emptyCollections);
            return {
                errorCode: 404,
                errorMessage: MoeErrorMessages.emptyCollections
            };
        }
    };

    // @info: This method checks whether given name already exists in the existing collections
    const doesDuplicatePendingNameExists = async (collectionId: number): Promise<any> => {
        const { context } = props;
        const collectionList = await getByCustomerAsync({ callerContext: context.actionContext, bypassCache: 'get' }, null);

        if (collectionList) {
            const pendingCollection: any = collectionList.filter((collection: any) => collection.Id === collectionId)[0];
            const activeCollections = collectionArray.filter(collection => collection.IsPrivate === false);
            const filteredItem = activeCollections.find(collection => collection?.Name === pendingCollection?.Name);
            console.log('filtered Item', filteredItem);
            if (filteredItem) {
                return true;
            } else {
                return false;
            }
        } else {
            setErrorMessage(MoeErrorMessages.emptyCollections);
            return {
                errorCode: 404,
                errorMessage: MoeErrorMessages.emptyCollections
            };
        }
    };

    // @info: This method updates the collection name using collection id and new name
    const updateCollectionName = async (collectionId: number, changedCollectionName: string, setCollectionTitle: any) => {
        const { telemetry } = props.context;
        setErrorMessage('');
        const isNetworkAvailable = isInternetConnectionAvailable();
        if (isNetworkAvailable === false) {
            setErrorMessage(MoeErrorMessages.networkOffline);
            return;
        }
        if (!user?.isAuthenticated) {
            setErrorMessage(MoeErrorMessages.unAuthenticated);
            return;
        }

        const isCollectionAvailable = await doesCollectionExist(collectionId);
        if (isCollectionAvailable) {
            const isDuplicateName = await doesDuplicateNameExists(changedCollectionName);
            if (!isDuplicateName) {
                try {
                    const updateCommerceList = await updateAsync(
                        { callerContext: props.context.actionContext },
                        { Id: collectionId, Name: changedCollectionName }
                    );
                    // const collectionList = collectionArray.map(collection => {
                    //     if (collection?.Id === collectionId) {
                    //         collection.Name = changedCollectionName;
                    //     }
                    //     return collection;
                    // });
                    // setCollectionArray(collectionList);
                    const collectionList = await getByCustomerAsync(
                        { callerContext: props.context.actionContext, bypassCache: 'get' },
                        null
                    );
                    setCollectionArray([...collectionList]);
                    console.log('Updated commerce list', updateCommerceList);
                    openAlert(moeSuccessMessages.updateCollectionName, false);
                } catch (e) {
                    setErrorMessage(MoeErrorMessages.unknownError);
                    console.log(e);
                }
            } else {
                setErrorMessage(MoeErrorMessages.duplicateName);
                const filteredItem = collectionArray.find(collection => collection?.Id === collectionId);
                console.log('Filtered item in update collection', filteredItem);
                setCollectionTitle(filteredItem?.Name);
                return {
                    errorCode: 400,
                    errorMessage: 'Same name already exists in collection'
                };
            }
        } else {
            setErrorMessage(MoeErrorMessages.emptyCollection);
            telemetry.debug("[Update] Can't update from wishlist since no wishlist exists OR there is no product data");
        }

        return AsyncResult.resolve();
    };

    // @info: This method updates the collection name using collection id and new name
    const acceptPendingCollections = async () => {
        const { telemetry } = props.context;
        setErrorMessage('');
        const isNetworkAvailable = isInternetConnectionAvailable();
        if (isNetworkAvailable === false) {
            setErrorMessage(MoeErrorMessages.networkOffline);
            return;
        }
        if (!user?.isAuthenticated) {
            setErrorMessage(MoeErrorMessages.unAuthenticated);
            return;
        }
        if (!sharedCollectionIDs) {
            console.log('Inside the accept pending collections fn');
            return;
        }

        for (const collectionId of sharedCollectionIDs) {
            const isCollectionAvailable = await doesCollectionExist(Number(collectionId));
            if (isCollectionAvailable) {
                const isDuplicatePendingName = await doesDuplicatePendingNameExists(Number(collectionId));
                if (!isDuplicatePendingName) {
                    try {
                        const updateCommerceList = await updateAsync(
                            { callerContext: props.context.actionContext },
                            { Id: Number(collectionId), IsPrivate: false }
                        );
                        console.log('Updated commerce list', updateCommerceList);
                    } catch (e) {
                        setErrorMessage(MoeErrorMessages.unknownError);
                        console.log(e);
                    }
                } else {
                    setErrorMessage(MoeErrorMessages.duplicatePendingName);
                    const filteredItem = collectionArray.find(collection => collection?.Id === collectionId);
                    console.log('Filtered item in update collection', filteredItem);
                    return {
                        errorCode: 400,
                        errorMessage: 'Same name already exists in collection'
                    };
                }
            } else {
                setErrorMessage(MoeErrorMessages.emptyCollection);
                telemetry.debug("[Update] Can't update from wishlist since no wishlist exists OR there is no product data");
            }
        }

        const collectionList = await getByCustomerAsync({ callerContext: props.context.actionContext, bypassCache: 'get' }, null);
        console.log('Collection list after accepting', collectionList);
        setCollectionArray([...collectionList]);
        openAlert(moeSuccessMessages.approvePendingCollection, true);
        // setTimeout(() => {
        //     location.reload();
        // }, 3000);
        return AsyncResult.resolve();
    };

    const toggleDelete = (collectionId?: number) => {
        setDelete(collectionId ?? null);
    };

    const _deleteModal = (): INodeProps => {
        return {
            tag: Modal,
            placement: 'bottom-end',
            hideArrow: false,
            className: 'msc-modal__dialog-success',
            wrapClassName: '',
            isOpen: isDelete,
            toggle: toggleDelete
        };
    };

    const handleDelete = async () => {
        if (isDelete) {
            toggleDelete();
            await deleteCollection(isDelete);
        }
    };

    // @info: This method deletes the collection using collection id
    const deleteCollection = async (collectionId: number): Promise<void> => {
        const isNetworkAvailable = isInternetConnectionAvailable();
        if (isNetworkAvailable === false) {
            setErrorMessage(MoeErrorMessages.networkOffline);
            return;
        }

        setErrorMessage('');
        const { context } = props;
        const { telemetry } = context;

        console.log('Delete collection');

        if (context.request.user.isAuthenticated) {
            const isCollectionAvailable = await doesCollectionExist(collectionId);
            if (isCollectionAvailable) {
                const collection = collectionArray.find(collectionItem => collectionItem.Id === collectionId);
                try {
                    const deleteCommerceList = await deleteAsync({ callerContext: props.context.actionContext }, { Id: collection.Id });
                    console.log('[RemoveCollection] collection deleted successfully', deleteCommerceList);
                } catch (e) {
                    setErrorMessage(MoeErrorMessages.unknownError);
                    console.log(e);
                }
            } else if (telemetry) {
                setErrorMessage(MoeErrorMessages.emptyCollection);
                telemetry.debug("[RemoveCollection] Can't remove collection since no collection exists ");
            }
        } else {
            setErrorMessage(MoeErrorMessages.unAuthenticated);
            return;
        }

        const collectionList = await getByCustomerAsync({ callerContext: props.context.actionContext, bypassCache: 'get' }, null);
        openAlert(moeSuccessMessages.deleteCollection, false);
        setCollectionArray(collectionList);
        return AsyncResult.resolve();
    };

    // @info: This method deletes the collection using collection id
    const deletePendingCollections = async (event: any): Promise<void> => {
        const isNetworkAvailable = isInternetConnectionAvailable();
        if (isNetworkAvailable === false) {
            setErrorMessage(MoeErrorMessages.networkOffline);
            return;
        }

        setErrorMessage('');
        event.stopPropagation();
        const { context } = props;
        const { telemetry } = context;

        console.log('Delete pending collections');

        if (context.request.user.isAuthenticated) {
            for (const collectionId of sharedCollectionIDs) {
                try {
                    const isCollectionAvailable = await deleteCollection(Number(collectionId));
                    telemetry.information('3', isCollectionAvailable);
                } catch (e) {
                    setErrorMessage(MoeErrorMessages.unknownError);
                }
            }
            openAlert(moeSuccessMessages.deletePendingCollection, false);
        } else {
            setErrorMessage(MoeErrorMessages.unAuthenticated);
            return;
        }

        return AsyncResult.resolve();
    };

    const areCollectionsAvailable = () => {
        if (!props?.config?.isPendingCollectionView) {
            const activeCollections = collectionArray.filter(collection => collection.IsPrivate === false);
            return activeCollections?.length > 0 ? true : false;
        } else {
            const pendingCollections = collectionArray.filter(collection => collection.IsPrivate === true);
            return pendingCollections?.length > 0 ? true : false;
        }
    };

    console.log('Are Collections Available', areCollectionsAvailable());

    const _alertModal = (): INodeProps => {
        return {
            tag: Modal,
            placement: 'bottom-end',
            hideArrow: false,
            className: 'msc-modal__dialog-success',
            wrapClassName: '',
            isOpen: isAlertOpen,
            toggle: () => {
                setAlertOpen(false);
                if (isRefreshPage) {
                    location.reload();
                }
            }
        };
    };
    const closeAlert = () => {
        setAlertOpen(false);
        setAlertMessage('');
        if (isRefreshPage) {
            setIsRefreshPage(false);
            location.reload();
        }
    };
    const openAlert = (msg: string, isreload: boolean) => {
        setAlertOpen(true);
        setAlertMessage(msg);
        setIsRefreshPage(isreload);
    };

    return (
        <div tabIndex={0} className='msc__view-collection-wrap'>
            {user?.isAuthenticated ? (
                <div className='msc__view-collection'>
                    <div className='modal fade' role='dialog' aria-hidden='true'>
                        <div className='modal-dialog modal-dialog-centered container' role='document'>
                            <div className='modal-content'>
                                <div className='msc-collection__header' tabIndex={0}>
                                    <h5 className='modal-title' tabIndex={0}>
                                        {collectionSiteLang === 'maori' ? props.config.modalTitleInMaori : props.config.modalTitle}
                                    </h5>
                                    {!props.config.isPendingCollectionView && (
                                        <FaShareAlt
                                            className='tooltip-test'
                                            opacity={sharedCollectionIDs.length > 0 ? 1 : 0.4}
                                            size={20}
                                            onClick={sharedCollectionIDs.length > 0 ? () => openShareCollectionModal() : () => {}}
                                            onKeyPress={e =>
                                                e.charCode === 13
                                                    ? sharedCollectionIDs.length > 0
                                                        ? openShareCollectionModal()
                                                        : () => {}
                                                    : null
                                            }
                                            cursor={sharedCollectionIDs.length > 0 ? 'pointer' : 'not-allowed'}
                                            title={
                                                collectionSiteLang === 'maori'
                                                    ? resources.shareCollectionsTextInMaori
                                                    : resources.shareCollectionsText
                                            }
                                            tabIndex={0}
                                        ></FaShareAlt>
                                    )}
                                    {props.config.isPendingCollectionView && (
                                        <div className='moe-approveCancel'>
                                            <FaCheck
                                                opacity={sharedCollectionIDs.length > 0 ? 1 : 0.4}
                                                size={25}
                                                tabIndex={0}
                                                cursor={sharedCollectionIDs.length > 0 ? 'pointer' : 'not-allowed'}
                                                className='approve tooltip-test'
                                                title={
                                                    collectionSiteLang === 'maori'
                                                        ? resources.approveCollectionTextInMaori
                                                        : resources.approveCollectionText
                                                }
                                                onClick={(sharedCollectionIDs.length > 0 ? acceptPendingCollections : '') as any}
                                                onKeyPress={e =>
                                                    e.charCode === 13
                                                        ? ((sharedCollectionIDs.length > 0 ? acceptPendingCollections() : '') as any)
                                                        : null
                                                }
                                            ></FaCheck>
                                            <FaTimesCircle
                                                opacity={sharedCollectionIDs.length > 0 ? 1 : 0.4}
                                                size={25}
                                                tabIndex={0}
                                                cursor={sharedCollectionIDs.length > 0 ? 'pointer' : 'not-allowed'}
                                                onClick={(sharedCollectionIDs.length > 0 ? deletePendingCollections : '') as any}
                                                onKeyPress={e =>
                                                    e.charCode === 13
                                                        ? ((sharedCollectionIDs.length > 0 ? deletePendingCollections(e) : '') as any)
                                                        : null
                                                }
                                                className='tooltip-test'
                                                title={
                                                    collectionSiteLang === 'maori'
                                                        ? resources.rejectCollectionTextInMaori
                                                        : resources.rejectCollectionText
                                                }
                                            ></FaTimesCircle>
                                        </div>
                                    )}
                                </div>
                                <div
                                    style={{ marginBottom: errorMessage ? '1rem' : '0rem' }}
                                    className={`moe-addtocollection-err--text moe-form__validation ${
                                        errorMessage ? 'fadeInTop' : 'fadeOutTop'
                                    }`}
                                >
                                    {errorMessage}
                                </div>
                                {areCollectionsAvailable() ? (
                                    <div className='msc-collection__body'>
                                        <div className='msc-collection__collections '>
                                            {!props.config.isPendingCollectionView &&
                                                collectionArray.map((collection: any, index) =>
                                                    collection.IsPrivate === true ? null : (
                                                        <CollectionItem
                                                            onCheckboxSelect={(
                                                                event: React.ChangeEvent<HTMLInputElement>,
                                                                collectionID: string,
                                                                isChecked: boolean
                                                            ) => onCheckboxSelect(event, collectionID, isChecked)}
                                                            typeName={'view'}
                                                            index={index}
                                                            isCheckboxEnabled={true}
                                                            collection={collection}
                                                            key={collection.Id}
                                                            isClickCollectionEnabled={true}
                                                            onClickCollection={(
                                                                index: number,
                                                                collectionId: number,
                                                                collectionProducts: any[]
                                                            ) => onClickCollection(index, collectionId, collectionProducts)}
                                                            context={props.context}
                                                            id={props?.id}
                                                            data={collection}
                                                            isEditEnabled={true}
                                                            isDeleteEnabled={true}
                                                            isTickMarkVisible={isCollectionEditable}
                                                            toggleEditableCollection={() => toggleEditableCollection(index)}
                                                            deleteCollection={(event, collectionId) => {
                                                                event.stopPropagation();
                                                                toggleDelete(collectionId);
                                                            }}
                                                            selectCollection={() => {
                                                                return;
                                                            }}
                                                            updateCollectionName={(
                                                                collectionId,
                                                                changedCollectionName,
                                                                setCollectionTitle
                                                            ) =>
                                                                updateCollectionName(
                                                                    collectionId,
                                                                    changedCollectionName,
                                                                    setCollectionTitle
                                                                )
                                                            }
                                                            selectedCollection={() => {
                                                                return;
                                                            }}
                                                            className='msc-collection-modal__collection'
                                                            redirectionLink={redirectionLink}
                                                            setErrorMessage={setErrorMessage}
                                                            MoeErrorMessages={MoeErrorMessages}
                                                            siteLang={collectionSiteLang}
                                                            otherSiteCollectionCount={otherSiteCollectionCount}
                                                        ></CollectionItem>
                                                    )
                                                )}

                                            {props.config.isPendingCollectionView &&
                                                collectionArray.map((collection: any, index) =>
                                                    collection.IsPrivate === true ? (
                                                        <CollectionItem
                                                            onCheckboxSelect={(
                                                                event: React.ChangeEvent<HTMLInputElement>,
                                                                collectionID: string,
                                                                isChecked: boolean
                                                            ) => onCheckboxSelect(event, collectionID, isChecked)}
                                                            typeName={'pending'}
                                                            index={index}
                                                            isCheckboxEnabled={true}
                                                            collection={collection}
                                                            key={collection.Id}
                                                            isClickCollectionEnabled={true}
                                                            onClickCollection={(
                                                                index: number,
                                                                collectionId: number,
                                                                collectionProducts: any[]
                                                            ) => onClickCollection(index, collectionId, collectionProducts)}
                                                            context={props.context}
                                                            id={props?.id}
                                                            data={collection}
                                                            isEditEnabled={true}
                                                            isDeleteEnabled={true}
                                                            isTickMarkVisible={isCollectionEditable}
                                                            toggleEditableCollection={() => toggleEditableCollection(index)}
                                                            deleteCollection={(event, collectionId) => {
                                                                event.stopPropagation();
                                                                toggleDelete(collectionId);
                                                            }}
                                                            selectCollection={() => {
                                                                return;
                                                            }}
                                                            updateCollectionName={(
                                                                collectionId,
                                                                changedCollectionName,
                                                                setCollectionTitle
                                                            ) =>
                                                                updateCollectionName(
                                                                    collectionId,
                                                                    changedCollectionName,
                                                                    setCollectionTitle
                                                                )
                                                            }
                                                            selectedCollection={() => {
                                                                return;
                                                            }}
                                                            className='msc-collection-modal__collection'
                                                            redirectionLink={redirectionLink}
                                                            setErrorMessage={setErrorMessage}
                                                            MoeErrorMessages={MoeErrorMessages}
                                                            preferredLanguageForError={errorOrNotificationMsgLang}
                                                            siteLang={collectionSiteLang}
                                                            otherSiteCollectionCount={otherSiteCollectionCount}
                                                        ></CollectionItem>
                                                    ) : null
                                                )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className='msc-collection-modal__body'>
                                        <div className='msc-alert msc-alert-warning'>
                                            {MoeProfileMessages.hey} {user.firstName || 'User'},{' '}
                                            {!props.config.isPendingCollectionView
                                                ? MoeProfileMessages.noCollections
                                                : MoeProfileMessages.pendingCollections}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className='msc-collection-modal__body'>
                    <div className='msc-alert msc-alert-warning'>{MoeProfileMessages.notLoginToViewCollection}</div>
                </div>
            )}
            <Node {..._shareCollectionModal()}>
                <div className='moe-share-collection-email--emoji'>
                    <FaEnvelopeOpenText />
                </div>
                <h1>{collectionSiteLang === 'maori' ? resources.shareCollectionsTextInMaori : resources.shareCollectionsText}</h1>
                <div
                    style={{ marginBottom: shareErrorMessage ? '1rem' : '0rem' }}
                    className={`moe-addtocollection-err--text moe-form__validation ${shareErrorMessage ? 'fadeInTop' : 'fadeOutTop'}`}
                >
                    {shareErrorMessage}
                </div>
                <div className='share-email-input'>
                    <input
                        className='share-email'
                        type='text'
                        size={30}
                        placeholder='Email address'
                        onChange={e => {
                            onShareEmailChange(e.target.value);
                        }}
                        value={collectionShareEmail}
                        aria-label='Share email'
                    />
                </div>
                <div className='moe-collection-share-email-footer'>
                    <Button
                        className={`moe-btn moe-btn--primary-blue ${
                            !collectionShareEmail ? 'msc-share-collection-modal__button' : ''
                        } tooltip-test`}
                        title={
                            !collectionShareEmail
                                ? MoeProfileMessages.noEmailShareCollectionTitle
                                : MoeProfileMessages.emailShareCollectionTitle
                        }
                        onClick={() => onShareCollectionButtonClick()}
                    >
                        {MoeProfileMessages.shareCollectionsText}
                    </Button>

                    <Button
                        className={`moe-btn moe-btn--primary-blue moe-share-collection-close__button tooltip-test`}
                        title={MoeProfileMessages.close}
                        onClick={() => setShareCollectionModalOpen(false)}
                    >
                        {MoeProfileMessages.close}
                    </Button>
                </div>
            </Node>
            <Node {..._alertModal()}>
                <div className='modal-content'>
                    <div className='msc-modal__header'>
                        <h5 className='msc-modal__title'>
                            <div>
                                <h5>{errorOrNotificationMsgLang === MAORI_LANG ? 'Kua tutuki' : 'Success'}</h5>
                            </div>
                        </h5>
                        <button
                            type='button'
                            onClick={() => {
                                closeAlert();
                            }}
                            className='msc-modal__close-button'
                            aria-label='Close'
                        ></button>
                    </div>
                    <div className='msc-alert msc-alert-success'>{alertMessage}</div>
                </div>
            </Node>
            <Node {..._deleteModal()}>
                <div className='modal-content'>
                    <div className='msc-modal__header'>
                        <h5 className='msc-modal__title'>
                            <div>
                                <h5>{MoeProfileMessages.deleteConfirmationText}</h5>
                            </div>
                        </h5>
                        <button type='button' onClick={() => toggleDelete()} className='msc-modal__close-button' aria-label='Close' />
                    </div>
                    <div className='msc-modal__footer'>
                        <button
                            onClick={handleDelete}
                            type='button'
                            aria-label='Confirm Delete'
                            className='msc-btn moe-btn moe-btn--primary-blue'
                        >
                            {MoeProfileMessages.yes}
                        </button>
                        <button
                            onClick={() => toggleDelete()}
                            type='button'
                            aria-label='Cancel Delete'
                            className='msc-btn moe-btn moe-btn--default-white'
                        >
                            {MoeProfileMessages.cancel}
                        </button>
                    </div>
                </div>
            </Node>
        </div>
    );
};
